import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import useForm from 'hooks/useForm';
import { getCommonValues } from 'utils/getCommonValues';
import config from 'utils/config';
import { AUTOMATIC, MANUAL } from 'utils/asset/markAsDoneModes';
function getCommonMarkAsDoneValues(assets) {
  var defaultValue = config.manualMarkAsDone ? MANUAL : AUTOMATIC;
  var markAsDoneModes = assets.map(function (asset) {
    return asset.markAsDoneMode;
  });
  if (markAsDoneModes.filter(Boolean).length === 0) {
    return defaultValue;
  }

  // Replace any undefined values with the default value within the assets
  var updatedAssets = assets.map(function (asset) {
    return _objectSpread(_objectSpread({}, asset), {}, {
      markAsDoneMode: asset.markAsDoneMode || defaultValue
    });
  });
  return getCommonValues('markAsDoneMode', updatedAssets) || 'mixed';
}
function getCommonCompletionModeValues(assets) {
  return assets.every(function (asset) {
    return asset.optional === true;
  }) ? 'optional' : assets.every(function (asset) {
    return asset.optional === false;
  }) ? 'required' : 'mixed';
}
export function useMultiAssetsForm(_ref) {
  var assets = _ref.assets;
  return useForm({
    fields: {
      locale: {
        getDefaultValue: function getDefaultValue() {
          return getCommonValues('locale', assets);
        }
      },
      completionTime: {
        getDefaultValue: function getDefaultValue() {
          return getCommonValues('completionTime', assets);
        }
      },
      markAsDoneMode: {
        getDefaultValue: function getDefaultValue() {
          return getCommonMarkAsDoneValues(assets);
        }
      },
      ownerTeamIds: {
        getDefaultValue: function getDefaultValue() {
          return assets === null || assets === void 0 ? void 0 : assets.map(function (asset) {
            return asset.ownerTeamId || null;
          });
        }
      },
      completionMode: {
        getDefaultValue: function getDefaultValue() {
          return getCommonCompletionModeValues(assets);
        }
      }
    }
  });
}